import React from "react";
import Chip from "@components/ui-components/Chip";
import cx from "classnames";
import PlusLight from "@assets/icons/plusLight.svg";
import PlusDark from "@assets/icons/plusDark.svg";
import BlueTick from "@assets/icons/BlueTick.svg";
import { useTheme } from "next-themes";
import ThemedImage from "@components/ui-components/ThemedImage";

type DiscoverMoreChipProps = {
  chipLabel: string;
  isChipSelected?: boolean;
  isChipDisabled?: boolean;
  chipSize?: "regular" | "small";
  showImg?: boolean;
  mounted?: boolean;
};

const DiscoverMoreChip = ({
  chipLabel,
  isChipSelected = false,
  isChipDisabled,
  chipSize = "regular",
  showImg = true,
  mounted = false
}: DiscoverMoreChipProps) => {
  const { resolvedTheme } = useTheme();
  return (
    <Chip selected={isChipSelected} disabled={isChipDisabled} size={chipSize}>
      <div className="flex items-center">
        <span
          itemProp="name"
          className={cx(
            "disable-select",
            isChipSelected
              ? "font-medium text-P500 dark:text-DP500"
              : "font-regular text-N600 dark:text-DN600",
            "mr-2 whitespace-nowrap text-readingTextMedium leading-readingTextMedium"
          )}
        >
          {chipLabel}
        </span>
        {showImg ? (
          <div className="h-5 w-5">
            <ThemedImage
              mounted={mounted}
              resolvedTheme={resolvedTheme}
              darkSrc={isChipSelected ? BlueTick : PlusDark}
              lightSrc={isChipSelected ? BlueTick : PlusLight}
              width={20}
              height={20}
              alt="icon"
            />
          </div>
        ) : null}
      </div>
    </Chip>
  );
};

export default DiscoverMoreChip;
